import { gql } from '@apollo/client'
import creditCardType from 'credit-card-type'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'

export const commerceHubPaymentTokenCreate = gql`
  mutation commerceHubPaymentTokenCreate(
    $ccNumber: String!
    $ccCid: String!
    $ccType: String!
    $ccExpMonth: String!
    $ccExpYear: String!
    $cardholderName: String
  ) {
      commerceHubPaymentTokenCreate(
          input: {
           cc_number: $ccNumber,
           cc_cid: $ccCid,
           cc_type: $ccType,
           cc_exp_month: $ccExpMonth,
           cc_exp_year: $ccExpYear,
           cardholder_name: $cardholderName
        }
      ) {
      public_hash
      payment_method_code
      details
    }
  }
`

export const commerceHubPaymentTokenDelete = gql`
  mutation deletePaymentToken(
    $publicHash: String!
  ) {
    deletePaymentToken(
        public_hash: $publicHash,
    ) {
      result
    }
  }
`

export interface CommerceHubPaymentToken {
  cc_number: string
  cc_cid: string
  cc_type: string
  cc_exp_month: string
  cc_exp_year: string
  cardholder_name: string
}

export interface DeletePaymentTokenOut {
  result: Boolean
}

export interface SetVaultPaymentMethodOnCartResponse {
  setPaymentMethodOnCart: {
    cart: {
      selected_payment_method: {
        code: string
      }
    }
  }
}

export const setVaultPaymentMethodOnCartMutation = gql`
  mutation setPaymentMethodOnCart(
    $cartId: String!
    $publicHash: String!
  ) {
    setPaymentMethodOnCart(
      input: {
        cart_id: $cartId,
        payment_method: {
          code: "${PAYMENT_METHOD.COMMERCE_HUB_VAULT}"
          commerce_hub_vault: {
            public_hash: $publicHash
          }
        }
      }
    ) {
      cart {
        selected_payment_method {
          code
          title
        }
      }
    }
  }
`

export const setCardPaymentMethodOnCartMutation = gql`
  mutation setPaymentMethodOnCart(
    $cartId: String!
    $ccNumber: String!
    $ccCid: String!
    $ccType: String!
    $ccExpMonth: String!
    $ccExpYear: String!
    $cardholderName: String
  ) {
    setPaymentMethodOnCart(
      input: {
        cart_id: $cartId,
        payment_method: {
          code: "${PAYMENT_METHOD.COMMERCE_HUB}"
          commerce_hub: {
            cc_number: $ccNumber,
            cc_cid: $ccCid,
            cc_type: $ccType,
            cc_exp_month: $ccExpMonth,
            cc_exp_year: $ccExpYear,
            cardholder_name: $cardholderName
            is_active_payment_token_enabler: true
          }
        }
      }
    ) {
      cart {
        selected_payment_method {
          code
          title
        }
      }
    }
  }
`

// Short code mapping specific to CommerceHub requirements
const CARD_TYPE_SHORT_CODE: Record<string, string> = {
  visa: 'VI',
  mastercard: 'MC',
  'american-express': 'AE',
  'diners-club': 'DC',
  discover: 'DI'
}

/**
 * Derive CommerceHub short credit card type code from a card number.
 * Returns empty string if type cannot be determined or not mapped.
 */
export const deriveCcType = (ccNumber: string): string => {
  if (!ccNumber) return ''
  const rawType = creditCardType(ccNumber)?.[0]?.type
  return rawType ? (CARD_TYPE_SHORT_CODE[rawType] || '') : ''
}
